import React, { useContext, useState } from 'react'
import { InitializeContext } from '../../../App';

type PortfolioCardProps = {
          image: string;
          title: string;
          desc: string;
};


export default function ServicesCard({ image, title, desc }: PortfolioCardProps) {
          const { theme } = useContext(InitializeContext);
          const [showMore, setShowMore] = useState<Boolean>(false);

          return (
                    <div className={`w-full ${theme ? 'bg-black' : 'bg-white'} p-4 md:pt-5 rounded-xl shadow-md flex flex-col group`}>
                              <div className="w-full h-[80%] overflow-hidden rounded-lg glass">
                                        <img
                                                  className="w-full h-[13rem] md:h-[16rem] lg:h-[14rem] object-cover group-hover:scale-105 duration-300 cursor-pointer"
                                                  src={image}
                                                  alt="portfolio"
                                                  loading='lazy'
                                        />
                              </div>
                              <div className="w-full mt-5">
                                        <h3 className="text-sm md:text-base font-semibold uppercase">
                                                  {title}
                                        </h3>
                                        <p className='mt-3 text-sm'>{desc?.length > 80 && !showMore
                                                  ? desc?.slice(0, 80) + "..."
                                                  : desc}{" "}
                                                  {desc?.length > 80 && (
                                                            <span
                                                                      onClick={() => setShowMore(!showMore)}
                                                                      className={`cursor-pointer font-semibold ${theme ? 'text-warning' : 'text-primary'}`}
                                                            >
                                                                      {showMore ? "Show Less" : "Show More"}
                                                            </span>
                                                  )}</p>
                              </div>
                    </div>
          );
}